import { render, staticRenderFns } from "./PostCardApi.vue?vue&type=template&id=0ea32037"
import script from "./PostCardApi.vue?vue&type=script&lang=js"
export * from "./PostCardApi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports